var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sudoku"},_vm._l((_vm.board),function(item){return _c('Square',_vm._b({key:item.sq,on:{"on-user-input":_vm.onChange,"on-key-up":_vm.onKeyUp}},'Square',item,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }